// Vendor imports
const React = require('react')
// Shared imports
const BemEntity = require('shared/bem')
// Client V2 common imports
const tag = require('client-v2/common/utils/hyperscript')

const bem = BemEntity('HeroSection')

class HeroSection extends React.PureComponent {
  constructor(props) {
    super(props)

    this.state = {
      currentSlide: 0,
      previousSlide: 6,
      click: false,
      gif: ''
    }
  }

  componentDidMount() {
    const intervalId = setInterval(() => this.updateSlide(), 3000);
    this.setState({ intervalId })
  }

  updateSlide() {
    this.setState({
      click: true,
      gif: '/img/logged-out-landing-v2/next.gif'
    })

    setTimeout(() => {
      this.setState((prevState) => {
        return {
          currentSlide: (prevState.currentSlide + 1) % 7,
          previousSlide: prevState.currentSlide,
          click: false,
          gif: ''
        }
      })
    }, 1000)
  }

  render() {
    return (
      tag('div', {
        className: bem.block()
      },
        tag('div', {
          className: bem.element('inner')
        },
          tag('div', {
            className: bem.element('image-wrapper')
          },
            tag('div', {
              className: bem.element('image')
            },
              tag('div', {
                className: bem.element('slide-wrapper')
              },
                this.props.slides.map((slide, index) => (
                  tag(Slide, {
                    key: `slide-${index}`,
                    isPrevious: this.state.previousSlide === index,
                    isCurrent: this.state.currentSlide === index,
                    slide
                  })
                ))
              ),
              tag('div', {
                className: bem.element('extension')
              }),
              tag('div', {
                className: bem.element('cursor', {
                  click: this.state.click
                })
              }),
              tag('img', {
                className: bem.element('next', {
                  click: this.state.click
                }),
                src: this.state.gif
              })
            )
          ),
          tag('div', {
            className: bem.element('text-wrapper')
          },
            tag('div', {
              className: bem.element('title')
            },
              `A curated internet.`,
              tag('br'),
              tag('span', {
                className: bem.element('title-emphasis')
              },
                `Without the noise.`
              )
            ),
            tag('div', {
              className: bem.element('subtitle')
            },
              `Mix finds the internet's hidden gems by using machine learning,
              editor picks, and best-in-class publishers.`
            )
          )
        )
      )
    )
  }
}

function Slide(props) {
  return (
    tag('div', {
      className: bem.element('slide', {
        previous: props.isPrevious,
        current: props.isCurrent
      })
    },
      tag('img', {
        className: bem.element('slide-image'),
        src: props.slide.image
      }),
      tag('div', {
        className: bem.element('slide-headline')
      },
        props.slide.headline
      )
    )
  )
}

if (__DEV__) {
  // Prop checking imports
  const PropTypes = require('prop-types')

  HeroSection.propTypes = {
    // Values
    className: PropTypes.string,
    slides: PropTypes.arrayOf(PropTypes.shape({
      image: PropTypes.string.isRequired,
      headline: PropTypes.string.isRequired
    }))
  }
}

module.exports = HeroSection
